import { render, staticRenderFns } from "./GoodsConsCQ.vue?vue&type=template&id=501cab30&scoped=true&"
import script from "./GoodsConsCQ.vue?vue&type=script&lang=js&"
export * from "./GoodsConsCQ.vue?vue&type=script&lang=js&"
import style0 from "./GoodsConsCQ.vue?vue&type=style&index=0&id=501cab30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501cab30",
  null
  
)

export default component.exports